<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-09-13 16:16:57
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-09-27 16:43:23
 * @Description: 
-->
<template>
  <div class="detail-container">
    <detail :data="detailData"></detail>
  </div>
</template>

<script>
import detail from "./components/detail";
import { getDetailAgency } from "common/js/api";

export default {
  components: {
    detail
  },

  data() {
    return {
      institutionCode: this.$route.query.institutionCode,
      detailData: {}
    };
  },

  mounted() {
    
    this.getDetail();
  },

  methods: {
    async getDetail() {
      const res = await getDetailAgency(this.institutionCode);
      this.detailData = res.result;
      this.detailData.basic.registeIs = this.detailData.basic.registeIs?'1':'0';
      this.detailData.basic.autoManaged = this.detailData.basic.autoManaged?'1':'0';
      this.detailData.basic.associationRegisteFinished = this.detailData.basic.associationRegisteFinished?'1':'0';
      this.Cookies.set("fundType", this.detailData.basic.fundType);
      this.$forceUpdate();
    }
  }
};
</script>

<style>
</style>

